import React from 'react';
import { css } from 'aphrodite';
import styles from './payment-styles';
import { ContentCard, ContentRow } from '../common';

const Payment = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Interactive map'}>
      <ContentRow>
        Payment settings
      </ContentRow>
    </ContentCard>
  </div>
);

export default Payment;



// WEBPACK FOOTER //
// ./src/components/payment/payment.js